import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import {makeStyles} from '@material-ui/core/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styles from './TabTitle.module.css';
import {callLogEvent} from '../../Util';
import {Stack} from '@mui/material';
// import chatIcon from '../../../Assets/svgs/newchat1.svg';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import chatIcon from "../../../Assets/svgs/New Chat.svg";

// import Tooltip from "@mui/material";
import {Tooltip} from '@mui/material';

// ... (makeStyles code remains the same)
const UaeMtuseStyles = makeStyles({
  root: {
    height: '35px',
    backgroundColor: '#005CBC !important',
    boxShadow: 'rgba(13, 102, 197, 0.08) 0px 5px 15px !important',
    color: '#fffdfdff !important',
    fontSize: '62px',
    position: 'fixed',
    display: 'block',
    width: '100%',
    paddingLeft: '50px',
    marginTop: '36px',
    '& .MuiToolbar-root': {
      minHeight: '11px',
    },
  },
  buttonFile: {
    borderRadius: '20px !important',
    padding: '4px 16px !important',
    textTransform: 'capitalize',
    float: 'right',
    color: ' #fafbfcff !important',
    fontSize: '10px !important',
    fontStyle: 'normal !important',
    fontWeight: 'bold',
    border: '.5px solid #ffffffff !important',
  },
});
const useStyles = makeStyles({
  root: {
    height: '30px',
    backgroundColor: '#FBFCFE !important',
    boxShadow: 'rgba(0, 92, 188, 0.08) 0px 5px 15px !important',
    color: '#3A3A3A !important',
    fontSize: '16px',
    position: 'fixed',
    display: 'block',
    width: '100%',
    marginTop: '38px',
    '& .MuiToolbar-root': {
      minHeight: '10px',
    },
  },
  buttonFile: {
    borderRadius: '24px !important',
    textTransform: 'capitalize',
    float: 'right',
    color: ' #005CBC !important',
    fontSize: '10px !important',
    fontStyle: 'normal !important',
    fontWeight: 'bold',
    border: '1px solid #005CBC !important',
  },
});

export interface TabTitleProps {
  title: any;
  handleClick: () => any;
  centerTitle?: any;
  chatTitle: string;
  handleBack?: () => any;
  isBackBtn?: boolean;
  isRecentQueries?: boolean;
  handleRecentQueries?: () => any;
  messages?: [];
  variant?: 'default' | 'uaemt';
}
const TabTitle = ({
  title,
  handleClick,
  centerTitle,
  variant = 'default',
  chatTitle,
  isBackBtn,
  handleBack,
  isRecentQueries,
  handleRecentQueries,
  messages,
}: TabTitleProps) => {
  const defaultClasses = useStyles();
  const uaeMtClasses = UaeMtuseStyles();
  const classes = variant === 'uaemt' ? uaeMtClasses : defaultClasses;
  // const classes = useStyles();
  let variable =
    messages &&
    messages?.length > 0 &&
    localStorage.getItem('DataSource') === 'topline'
      ? // ? 'The AI for BI tool is now available for Beta testing. You can ask questions for descriptive analysis on Frito-Lay’s topline performance, leveraging competitive benchmarking and POS data from the NA dashboard.'
        'Beta Testing'
      : '';
  let tooltipText =
    'The AI for BI tool is now available for Beta testing. You can ask questions for descriptive analysis on Frito-Lay’s topline performance, leveraging competitive benchmarking and POS data from the NA dashboard.';
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleClearChat = () => {
    handleClick && handleClick();
  };
  const getRecentQueries = () => {
    handleRecentQueries && handleRecentQueries();
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_RECENT_SEARCHES_BUTTON',
      'clicked on view the list of recent queries made by the user'
    );
  };
  const handleBackClick = () => {
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_BACK_BUTTON',
      'clicked on back button to return to dashboard page'
    );
    handleBack && handleBack();
  };
  const buttonStyles = {
    borderRadius: '20px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    border: '.5px solid #ffffff',
    color: '#fafbfc',
    fontSize: {xs: '0.8rem', sm: '0.875rem'},
    padding: {xs: '4px 12px', sm: '4px 16px'},
  };
  return (
    <Box sx={{flexGrow: 1}}>
      <AppBar
        className={classes.root}
        sx={{
          position: 'fixed',
          zIndex: '10 !important',
          paddingLeft: {
            xs: 0,
            sm: 'clamp(0.3rem, 3.4vw, 3.1rem)',
          },
        }}
      >
        <Toolbar>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {isBackBtn && (
              <IconButton
                onClick={handleBackClick}
                color='inherit'
                aria-label='back'
                sx={{
                  p: {xs: 0.25, sm: 0.5},
                  fontSize: {xs: '0.5rem', sm: '1.25rem'},
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            )}
            {variable && (
              <Tooltip
                title={tooltipText}
                arrow
              >
                <Typography
                  sx={{
                    flexShrink: 0,
                    fontWeight: 'bold',
                    color: '#005CBC',
                    fontSize: 'clamp(0.5rem, 0.9vw, 0.8rem)',
                    cursor: 'pointer',
                    border: '1px solid #005CBC',
                    padding: '2px 6px',
                    borderRadius: '12px',
                    flexGrow: 1,
                    ml: isBackBtn ? 'clamp(0.5rem, 2vw, 0.75rem)' : 0,
                  }}
                >
                  {variable}
                </Typography>
              </Tooltip>
            )}
          </Box>
          <Typography
            variant='h6'
            component='div'
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
          >
            {centerTitle}
          </Typography>
          <Stack
            direction='row'
            justifyContent='flex-end'
            alignItems='center'
            spacing={{xs: 1, sm: 2}}
            sx={{
              width: '100%',
              paddingRight: 'clamp(5px, 1.5vw, 20px)',
            }}
          >
            {isRecentQueries && (
              <Box sx={{display: {xs: 'none', sm: 'block'}}}>
                <Button
                  size='small'
                  onClick={getRecentQueries}
                  sx={buttonStyles}
                  className={classes.buttonFile}
                >
                  Recent Queries
                </Button>
              </Box>
            )}

            {isMobile ? (
              <IconButton
                size='small'
                onClick={handleClearChat}
              >
                <img
                  src={chatIcon}
                  style={{width: '40px', height: '50px', marginRight: '-25px'}}
                  alt='New Chat'
                />
              </IconButton>
            ) : (
              <Button
                size='small'
                onClick={handleClearChat}
                className={classes.buttonFile}
                sx={buttonStyles}
              >
                {chatTitle}
              </Button>
            )}
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default TabTitle;
